import z from "zod";

export const zExtensionEventType = z.enum([
  "ON_OPEN",
  "BEFORE_SAVE",
  "AFTER_SAVE",
]);
export type ZExtensionEventType = z.infer<typeof zExtensionEventType>;

export const extensionEventLabels: Record<ZExtensionEventType, string> = {
  ON_OPEN: "При открытии",
  BEFORE_SAVE: "Перед сохранением",
  AFTER_SAVE: "После сохранения",
};

export const extensionEventTypes: ZExtensionEventType[] = [
  "ON_OPEN",
  "BEFORE_SAVE",
  "AFTER_SAVE",
];

export enum ExtensionBindingObjectType {
  Catalog = "CATALOG",
  Classifier = "CLASSIFIER",
}

export const zBoundExtension = z.object({
  id: z.string(),
  displayId: z.number(),
  name: z.string(),
  description: z.string().nullish(),
});
export type ZBoundExtension = z.infer<typeof zBoundExtension>;

export const zObjectExtensionBinding = z.object({
  id: z.string(),
  event: zExtensionEventType,
  extension: zBoundExtension,
});
export type ZObjectExtensionBinding = z.infer<typeof zObjectExtensionBinding>;

export const zObjectExtensionWrite = z.object({
  event: zExtensionEventType,
  extensionId: z.string(),
});
export type ZObjectExtensionWrite = z.infer<typeof zObjectExtensionWrite>;

export const zExtensionFormBinding = z.object({
  event: zExtensionEventType,
  extension: zBoundExtension,
});
export type ZExtensionFormBinding = z.infer<typeof zExtensionFormBinding>;
